module.exports = __webpack_public_path__ + "static/media/beer-de.fb26e1ab.png";